import type { SelectPromotionType, ViewPromotionType } from '../promotionEvents/types/types';
import { trackArray } from 'modules/tracking/dataLayer';
import debounce from 'lodash/debounce';

type DataObject = SelectPromotionType | ViewPromotionType;

const batch: DataObject[] = [];
const debounceDelay = 1000;

function pushBatch(): void {
    if (batch.length > 0) {
        trackArray(batch);
        batch.length = 0;
    }
}

const debouncedPushBatch = debounce(pushBatch, debounceDelay);

export default function addToDataLayerBatch(obj: DataObject): void {
    batch.push(obj);
    debouncedPushBatch();
}
